module.exports = __webpack_public_path__ + "fonts/Lato-BlackItalic.4c66fb2b.ttf";